module.exports = __webpack_public_path__ + "static/media/si_4.a16ae1b4.JPG";